import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import getVisits from "@/api/visits/getVisits";
import getDocument from "@/api/visits/getDocument";
import getTimetable from "@/api/timetable/getTimetable";
import getTimetableInfo from "@/api/timetable/getTimetableInfo";
import getPrepareInfo from "@/api/timetable/getPrepareInfo";
import orderTimeTable from "@/api/timetable/orderTimeTable";
import getPaymentLink from "@/api/payment/getPaymentLink";
import orderGuestTimeTable from "@/api/timetable/orderGuestTimeTable";
Vue.use(Vuex)


const state = {
    visitsDiagnostic: {
        data: [],
        loading: false
    },
    visitsSpecialization: {
        data: [],
        loading: false
    },
    visitsOtherServices: {
        data: [],
        loading: false
    },
}
const mutations = {
    SET_VISITS_DIAGNOSTIC(state, payload) {
        state.visitsDiagnostic = { ...state.visitsDiagnostic, ...payload };
    },
    SET_VISITS_SPECIALIZATION(state, payload) {
        state.visitsSpecialization = { ...state.visitsSpecialization, ...payload };
    },
    SET_VISITS_OTHER_SERVICES(state, payload) {
        state.visitsOtherServices = { ...state.visitsOtherServices, ...payload };
    },
}

const actions = {
    getVisits({commit, dispatch}, payload) {
        for (const idx in payload.serviceTypes) {
            switch (payload.serviceTypes[idx]){
                case 'specialization':
                    commit('SET_VISITS_SPECIALIZATION', { loading: true });
                    break
                case 'diagnostic':
                    commit('SET_VISITS_DIAGNOSTIC', { loading: true });
                    break
                case 'otherService':
                    commit('SET_VISITS_OTHER_SERVICES', { loading: true });
                    break
            }
        }

        return getVisits(payload).then((response) => {
            const [completed, planned, result] = [response['CMP'], response['PLN'], { "PLN":[], "CMP":[] }]

            for (const idx in payload.serviceTypes) {
                let result = []
                switch (payload.serviceTypes[idx]){
                    case 'specialization':
                        if(completed && Object.keys(completed).length > 0){
                            let completedFiltered = completed.filter((item) => item.service_type.type === 'specialization')
                            result['CMP'] = _.orderBy(completedFiltered,['date_time'],['desc'])
                        }
                        if(planned && Object.keys(planned).length > 0){
                            let plannedFiltered = planned.filter((item) => item.service_type.type === 'specialization')
                            result['PLN'] = _.orderBy(plannedFiltered,['date_time'],['desc'])
                        }

                        commit('SET_VISITS_SPECIALIZATION', {
                            data: result,
                            loading: false
                        });
                        break
                    case 'diagnostic':
                        if(completed && Object.keys(completed).length > 0){
                            let completedFiltered = completed.filter((item) => item.service_type.type === 'diagnostic')
                            result['CMP'] = _.orderBy(completedFiltered,['date_time'],['desc'])
                        }
                        if(planned && Object.keys(planned).length > 0){
                            let plannedFiltered = planned.filter((item) => item.service_type.type === 'diagnostic')
                            result['PLN'] = _.orderBy(plannedFiltered,['date_time'],['desc'])
                        }

                        commit('SET_VISITS_DIAGNOSTIC', {
                            data: result,
                            loading: false
                        });
                        break
                    case 'otherService':
                        if(completed && Object.keys(completed).length > 0){
                            let completedFiltered = completed.filter((item) => item.service_type.type === 'otherService')
                            result['CMP'] = _.orderBy(completedFiltered,['date_time'],['desc'])
                        }
                        if(planned && Object.keys(planned).length > 0){
                            let plannedFiltered = planned.filter((item) => item.service_type.type === 'otherService')
                            result['PLN'] = _.orderBy(plannedFiltered,['date_time'],['desc'])
                        }

                        commit('SET_VISITS_OTHER_SERVICES', {
                            data: result,
                            loading: false
                        });
                        break
                }
            }


        })

    },
    getVisitDocument({commit},payload){
        return getDocument(payload)
    },
    getTimeTables({commit},payload){
        //todo maybe need save in store
        return getTimetable(payload)
    },
    getTimeTableInfo({commit},payload){
        //todo maybe need save in store
        return getTimetableInfo(payload)
    },
    getPrepareInfo({commit},payload){
        //todo maybe need save in store
        return getPrepareInfo(payload)
    },
    orderDoctorTimeTable({commit},payload){
        return orderTimeTable(payload)
    },
    orderGuestTimeTable({commit},payload){
        return orderGuestTimeTable(payload)
    },
    getPaymentLink({commit},payload){
        return getPaymentLink(payload)
    }
}

export default {
    state,
    mutations,
    actions
}
